import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  changeIsOpen: `${NAMESPACE}_CHANGE_IS_OPEN`
};

export const actionCreators = {
  changeIsOpen: payload => ({ type: actions.changeIsOpen, payload })
};

export default {
  actions,
  actionCreators,
};
